import { Injectable } from '@angular/core';
import { map, throwError } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
    providedIn: 'root'
})
export class ServiciosService {

    constructor(private api: ApiService) {}



    /* -------------------------------------------------------------------------- */
    /*                               MOSTRAR PAISES                               */
    /* -------------------------------------------------------------------------- */
    mostrarServicios(_token, _limit, offset, valor, tipo, modo, convenio = 0) {
      const search = valor === '' ? 'vacio' : valor;

      switch (modo) {
        case 'buscar-servicio':
          return this.withLegacyTotal(
            this.api.post<any>('/inventory/services/list', {
              offset: Number(offset) || 0,
              search,
              tipo: tipo || '',
              convenio: Number(convenio) || 0
            })
          );

        case 'buscar-servicio-paquete':
          return this.withLegacyTotal(
            this.api.post<any>('/inventory/services/package/list', {
              offset: Number(offset) || 0,
              search,
              tipo: tipo || ''
            })
          );

        case 'obtener-servicio-item':
          return this.api.post<any>('/inventory/services/find', {
            field: tipo,
            value: valor
          });

        case 'obtener-servicio-orden':
          return this.api.post<any>('/inventory/services/order-list', {
            orden: offset,
            field: tipo,
            value: valor
          });

        case 'obtener-perfiles':
          return this.api.post<any>('/inventory/services/profiles', {
            valor: valor ?? 'null',
            field: tipo ?? 'null'
          });

        case 'obtener-productos-perfiles':
          return this.api.post<any>('/inventory/services/profile-products', {
            valor
          });

        case 'estado-facturacion-laboratorio':
          return this.api.post<any>('/inventory/services/lab-billing-status', {
            codPro: valor
          });

        default:
          return throwError(() => new Error(`Modo de servicios no soportado: ${modo}`));
      }
    }

    mostrarServiciosConSubServicios(_token) {
        return this.api.post<any>('/inventory/services/with-sub-services/list', {}).pipe(
            map(resp => resp.rows)
        );
    }


    mostrarSubServiciosById(_token, idServicio) {
        return this.api.post<any>('/inventory/services/sub-services/find', {
            serviceId: idServicio,
        }).pipe(
            map(resp => resp.rows)
        );
    }

  validarFacturacionLaboratorio(_token, codPro) {
    return this.api.post<any>('/inventory/services/lab-billing-status', {
      codPro
    });
  }

  private withLegacyTotal(request) {
    return request.pipe(
      map((resp: any) => ({
        ...resp,
        total: resp.pagination?.total ?? 0
      }))
    );
  }
}
